export default "__VITE_ASSET__CV7wGB0q__"